//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Input from 'ui-kit/src/components/form/Input';
import Autocomplete from '@/mixins/Autocomplete';

export default {
    extends: Input,

    mixins: [
        Autocomplete,
    ],

    props: {
        enumKey: String,
        isDirty: Boolean,
    },

    computed: {
        enum() {
            return $.enums.find(e => e.key === this.enumKey);
        },
        options() {
            return this.enum.values;
        },
        detail() {
            return $.getDetail(types.enums.pageName, this.enum.id);
        },
        confirmDialogProps() {
            return !this.isDirty ? undefined : {
                title: this.$t(`confirm.goToDetail.title.enums.${this.enumKey}`),
                message: this.$t(`confirm.goToDetail.message`),
            };
        },
    },

    methods: {
        getSearchText(item) {
            return $.removeAccents(item).toLowerCase();
        },
    },
};
